/* @flow */

type PeriodFilter = 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'quarters' | 'years';

export function getDurationString(chr: string): PeriodFilter {
    switch (chr) {
        case 'M':
            return 'minutes';
        case 'h':
            return 'hours';
        case 'd':
            return 'days';
        case 'w':
            return 'weeks';
        case 'm':
            return 'months';
        case 'q':
            return 'quarters';
        case 'y':
            return 'years';
        default:
            return 'months';
    }
}
